/**
 * Utility to calculate the updated ranking based on live results.
 */

export const calculateUpdatedRanking = (currentRanking, recalculatedMatches) => {
  if (! currentRanking || ! currentRanking.standings) {
    return currentRanking;
  }

  const standings = JSON.parse(JSON.stringify(currentRanking.standings));
  const teamsUsers = currentRanking.teamsUsers;
  const teamsNames = currentRanking.teamsNames;

  // Initialize pointsGained
  standings.forEach(team => {
    team.pointsGained = 0;
  });

  // Process each match: remove live stats and add recalculated stats
  recalculatedMatches.forEach(match => {
    const homeTeam = standings.find(s => s.teamId === match.home.teamId);
    const awayTeam = standings.find(s => s.teamId === match.away.teamId);

    if (! homeTeam || ! awayTeam) {
      return;
    }

    // Remove live stats
    updateTeamStats(homeTeam, match.home.score, match.away.score, - 1);
    updateTeamStats(awayTeam, match.away.score, match.home.score, - 1);

    // Add recalculated stats if available, otherwise restore original
    if (match.recalculated && match.recalculated.score) {
      const [recHomeScore, recAwayScore] = match.recalculated.score;
      const homePoints = getPoints(recHomeScore, recAwayScore);
      const awayPoints = getPoints(recAwayScore, recHomeScore);

      updateTeamStats(homeTeam, recHomeScore, recAwayScore, 1);
      updateTeamStats(awayTeam, recAwayScore, recHomeScore, 1);

      homeTeam.pointsGained += homePoints;
      awayTeam.pointsGained += awayPoints;
    } else {
      // No recalculated result: restore original stats
      updateTeamStats(homeTeam, match.home.score, match.away.score, 1);
      updateTeamStats(awayTeam, match.away.score, match.home.score, 1);
    }
  });

  // 3. Re-sort and re-rank
  standings.sort((a, b) => {
    if (b.points !== a.points) {
      return b.points - a.points;
    }
    if (b.difference !== a.difference) {
      return b.difference - a.difference;
    }
    return b.goals - a.goals;
  });

  standings.forEach((team, index) => {
    team.rank = index + 1;
  });

  return {
    standings,
    teamsUsers,
    teamsNames,
  };
};

const getPoints = (goalsFor, goalsAgainst) => {
  if (goalsFor > goalsAgainst) {
    return 3;
  }
  if (goalsFor === goalsAgainst) {
    return 1;
  }
  return 0;
};

const updateTeamStats = (team, goalsFor, goalsAgainst, multiplier) => {
  team.played += 1 * multiplier;
  team.goals += goalsFor * multiplier;
  team.goalsConceded += goalsAgainst * multiplier;
  team.difference = team.goals - team.goalsConceded;

  const points = getPoints(goalsFor, goalsAgainst);
  team.points += points * multiplier;

  if (goalsFor > goalsAgainst) {
    team.won += 1 * multiplier;
  } else if (goalsFor === goalsAgainst) {
    team.drawn += 1 * multiplier;
  } else {
    team.lost += 1 * multiplier;
  }
};